export default __webpack_public_path__ + "static/media/mst.1214f244.png";